import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 6.00016L6 10.0002C4 12.0002 4 16.0014 4 16.0014C4 16.0014 7.99879 16.0014 10 14.0002L14 10.0002M10 6.00016L14 10.0002M10 6.00016L12.5 3.50004C13.0839 3.49516 14.4617 3.9617 15.25 4.75004C16.0383 5.53837 16.5049 6.91621 16.5 7.50012L14 10.0002",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})
});
export default SvgEdit;
